import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge", "icon", "text"]
  static values = { url: String }

  async verify(event) {
    event.preventDefault()
    
    // Prevent double-clicks while verifying
    if (this.isVerifying) return
    this.isVerifying = true
    
    // Immediate loading state
    this.textTarget.textContent = "Verifying..."
    this.iconTarget.classList.add("animate-spin")
    
    // Update badge to verifying state colors
    this.badgeTarget.classList.remove(
      "bg-emerald-100", "dark:bg-emerald-900/30", "text-emerald-700", "dark:text-emerald-400",
      "bg-amber-100", "dark:bg-amber-900/30", "text-amber-900", "dark:text-amber-300",
      "bg-red-100", "dark:bg-red-900/30", "text-red-700", "dark:text-red-400",
      "hover:bg-emerald-200", "dark:hover:bg-emerald-900/50",
      "hover:bg-amber-200", "dark:hover:bg-amber-900/50",
      "hover:bg-red-200", "dark:hover:bg-red-900/50",
      "cursor-pointer"
    )
    this.badgeTarget.classList.add(
      "bg-blue-100", "dark:bg-blue-900/30", 
      "text-blue-700", "dark:text-blue-400",
      "cursor-wait"
    )
    
    try {
      // POST to verify endpoint with Turbo Stream accept header
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        // Turbo will process the stream response and replace the element
        Turbo.renderStreamMessage(html)
      } else {
        // If the request failed, show error state
        this.showError("Verification failed")
      }
    } catch (error) {
      console.error("[ConnectionVerify] Error:", error)
      this.showError("Network error")
    }
    
    this.isVerifying = false
  }
  
  showError(message) {
    this.textTarget.textContent = "Error"
    this.iconTarget.classList.remove("animate-spin")
    this.badgeTarget.classList.remove(
      "bg-blue-100", "dark:bg-blue-900/30", 
      "text-blue-700", "dark:text-blue-400",
      "cursor-wait"
    )
    this.badgeTarget.classList.add(
      "bg-red-100", "dark:bg-red-900/30", 
      "text-red-700", "dark:text-red-400",
      "cursor-pointer"
    )
  }
}
